import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class InstitutionDataService {
  constructor(private httpClient: HttpClient) { }

  //Add  saveinstitutionForm
  public saveinstitutionFormandCreateOrder(data): Observable<any> {
    return this.httpClient.post('institution/register/createOrder', data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }

  // Get All  
  public getAllinstitution(data): Observable<any> {
    return this.httpClient.post('institution/get/getAll', data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }

  //Enable And Disable Institution
  public enableanddisableInstitution(data): Observable<any> {
    return this.httpClient.post('institution/enabledisable', data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }

  //Activate Institution
  public ActivateInstitution(data): Observable<any> {
    return this.httpClient.post('institution/approveInstitution', data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }

  //createOrder 
  public createOrder(data): Observable<any> {
    return this.httpClient.post('payment/createorder', data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }

  //Get Institution By Login
  public getInstitutionByLogin(): Observable<any> {
    return this.httpClient.get('institution/get/institution').pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }

  //get Module By Institution Id
  public getModuleByInstitutionId(id): Observable<any> {
    return this.httpClient.get('institution/getModulesForInstitution/' + id).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }

  //get Institution By ID
  public getInstitutionByID(id): Observable<any> {
    return this.httpClient.get('institution/get/' + id).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }

  //get Institution By ID
  public getAllModulesForInstitutionwithPaginationTest(data): Observable<any> {
    return this.httpClient.post('institution/getAllModulesForInstitutionwithPagination', data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }

  //Add Modules For Institution
  public AddModulesForInstitution(id): Observable<any> {
    return this.httpClient.get('institution/AddModulesForInstitution/' + id).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }


  //get Modules For Institution
  public getModulesForInstitution(data): Observable<any> {
    return this.httpClient.post('institution/getModulesForInstitution', data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }

  //get InProgress Modules By InstitutionId 
  public getInProgressModulesByInstitutionId(data): Observable<any> {
    return this.httpClient.post('institution/getInProgressModulesByInstitutionId', data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }

  //update Institution By ID
  public updateInstitutionByID(id, data): Observable<any> {
    return this.httpClient.put('institution/' + id, data).pipe(tap(res => {
      return res;

    }), catchError(error => throwError(() => error)));
  }

  //getInstitutionByProfile
  public getInstitutionByProfile(data): Observable<any> {
    return this.httpClient.post('institution/institutionProfile', data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }
  // getStudentDetailsForCompletedModules
  public getStudentDetailsForCompletedModules(data): Observable<any> {
    return this.httpClient.post('moduleCompletion/getStudentDetailsForCompletedModules', data).pipe(
      tap((res) => {
        return res;
      }),
      catchError((error) => throwError(() => error))
    );
  }

  // getAllEventsByType
  public getAllEventsByType(data): Observable<any> {
    return this.httpClient.post('eventSchedule/get/getEventScheduleBasedEventType', data).pipe(
      tap((res) => {
        return res;
      }),
      catchError((error) => throwError(() => error))
    );
  }
  // Get All Language 
  public getAllLanguages(): Observable<any> {
    return this.httpClient.get('language/getAllLanguage').pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }

  // Get All Institution Student Count
  public getAllinstitutionStudentCount(data): Observable<any> {
    return this.httpClient.post('institution/getAllInstitutionWithStudent',data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }
}